import React from "react";
import { cn } from "@sys42/utils";

import * as styles from "./styles.module.css";

export function StatusTags({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}) {
  return <span className={cn(className, styles.statusTags)}>{children}</span>;
}

export function StatusTag({
  className,
  status,
  children,
}: {
  className?: string;
  status: "published" | "draft" | "modified" | "inReview";
  children: React.ReactNode;
}) {
  return (
    <span
      className={cn(
        className,
        styles.statusTag,
        status === "published" && styles.statusTag_published,
        status === "draft" && styles.statusTag_draft,
        status === "modified" && styles.statusTag_modified,
        status === "inReview" && styles.statusTag_inReview,
      )}
    >
      {children}
    </span>
  );
}
